'use client';

import QAInspector from './QAInspector/index';

export default QAInspector;
